/*
 * Hexlox Product Finder — analytics (GA4 through Google Tag Manager).
 *
 * Hands Finder events to the page's dataLayer, where a GTM tag forwards them to GA4. Nothing is
 * pushed unless the visitor allowed analytics: the shop's cookie banner (Pandectes) reports the
 * choice to Shopify's Customer Privacy API, and we ask that API before every event. If the API is
 * missing or unsure, nothing is sent.
 *
 *   HexloxFinderAnalytics.create(opts) -> { track(name, params) }
 *
 *   opts.version      finder_version from the config, sent with every event
 *   opts.placement    where this Finder sits: "bar" (pinned bar, footer) or "page" (on a page),
 *                     sent with every event as finder_placement
 *   opts.consent()    -> true only when analytics is allowed (default: Shopify Customer Privacy API)
 *   opts.dataLayer()  -> the array to push to (default: window.dataLayer, created if missing)
 *
 * Every event has the same flat keys (null when not used), so a value from one event never
 * lingers into the next one in GTM's data model.
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.HexloxFinderAnalytics = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var EVENTS = ['finder_open', 'part_selected', 'question_answered', 'finder_complete', 'add_to_cart_success', 'add_to_cart_error'];
  var KEYS = ['finder_part', 'finder_question', 'finder_answer', 'finder_parts', 'finder_products', 'finder_error'];

  function shopifyConsent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed() === true);
    } catch (e) {
      return false;
    }
  }

  function pageDataLayer() {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }

  function create(opts) {
    opts = opts || {};
    var consent = opts.consent || shopifyConsent;
    var layer = opts.dataLayer || pageDataLayer;

    function track(name, params) {
      if (EVENTS.indexOf(name) === -1) throw new Error('Hexlox Finder: unknown analytics event ' + name);
      if (!consent()) return false;
      var data = { event: name, finder_version: String(opts.version || ''), finder_placement: opts.placement || 'bar' };
      KEYS.forEach(function (k) {
        var v = params && params[k];
        data[k] = v === undefined || v === null || v === '' ? null : v;
      });
      try {
        layer().push(data);
      } catch (e) {
        return false; // analytics must never break the Finder
      }
      return true;
    }

    return { track: track };
  }

  return { create: create, EVENTS: EVENTS, KEYS: KEYS };
});
